import { Button, CircularProgress, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { Html5Qrcode, Html5QrcodeScannerState } from "html5-qrcode";
import React, { useEffect, useRef, useState } from "react";

export default function QRScannerView({ show, setValue, exit, width }) {
  const [scanner, setScanner] = useState();
  const [scannedCode, setScannedCode] = useState("");
  const [details, setDetails] = useState();
  const [devices, setDevices] = useState();
  const [cameraId, setCameraId] = useState();
  const ref = useRef();
  const canvasarea = 500;

  const qrboxFunction = (viewfinderWidth, viewfinderHeight) => {
    let minEdgePercentage = 0.7; // 70%
    let minEdgeSize = Math.min(viewfinderWidth, viewfinderHeight);
    let qrboxSize = Math.floor(minEdgeSize * minEdgePercentage);
    return {
      width: qrboxSize,
      height: qrboxSize,
    };
  };

  const readSuccess = (e, f) => {
    if (f && f.decodedText) {
      setScannedCode(f.decodedText);
      setDetails(JSON.stringify(f.result.format));
    }
    if (!e || !e.data) {
      return;
    }
    setScannedCode(e.data);
  };

  useEffect(() => {
    const func = async () => {
      if (ref.current) {
        try {
          var devs = await Html5Qrcode.getCameras();
          var v;
          if (devs && devs.length) {
            setDevices(devs);
            v = new Html5Qrcode(ref.current.id);
            setCameraId(devs[0].id);
          }
          setScanner(v);
        } catch (error) {
          console.log(error);
        }
      }
    };
    func();
  }, [ref]);

  useEffect(() => {
    if (scannedCode && scanner) {
      scanner.pause();
    }
  }, [scannedCode, scanner]);

  const close = () => {
    try {
      if (scanner) {
        scanner.stop();
      }
    } catch (error) {}

    setScannedCode("");
    setValue(scannedCode);
    exit();
  };

  return show ? (
    <Grid container>
      <Grid item xs={12}>
        <Typography>Code Scanner</Typography>
      </Grid>
      <Grid item>
        {scanner && cameraId ? (
          <>
            {devices && devices.length > 1 ? (
              <>
                <Typography>
                  Select Camera To{" "}
                  {scanner.getState() === Html5QrcodeScannerState.PAUSED
                    ? "Rescan"
                    : "Start"}
                </Typography>
                <ToggleButtonGroup
                  exclusive
                  onChange={(e, v) => {
                    try {
                      scanner.stop();
                    } catch (error) {}
                    try {
                      setTimeout(() => {
                        setCameraId(v);
                        scanner.start(
                          {
                            deviceId: {
                              exact: v,
                            },
                          },
                          { qrbox: qrboxFunction },
                          readSuccess
                        );
                      }, 100);
                    } catch (error) {}
                  }}
                >
                  {" "}
                  {devices.map((m, i) => (
                    <ToggleButton variant="outlined" value={m.id} key={m.id}>
                      {i}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              </>
            ) : (
              <Button
                onClick={() => {
                  try {
                    scanner.start(
                      cameraId,
                      { qrbox: qrboxFunction },
                      readSuccess
                    );
                  } catch (error) {
                    try {
                      scanner.resume();
                    } catch (error) {}
                  }
                }}
                variant="outlined"
              >
                {scanner.getState() === Html5QrcodeScannerState.PAUSED
                  ? "Rescan"
                  : "Scan Barcode or QRCode with camera"}
              </Button>
            )}
          </>
        ) : (
          <CircularProgress />
        )}
      </Grid>
      <div
        ref={ref}
        id={"qr-canvasdsafasdfasdfdasfsd"}
        style={{ width: width === "xs" ? window.innerWidth : canvasarea }}
      ></div>
      <Grid item xs={12}>
        {scannedCode ? (
          <Typography>Scanned Code {scannedCode}</Typography>
        ) : null}
        {details && <Typography>Details {details}</Typography>}
      </Grid>
      <Grid item xs={12}>
        <Button variant="outlined" onClick={close}>
          OK
        </Button>
      </Grid>
    </Grid>
  ) : null;
}
